define( [
	"./arr"
], function( arr ) {
	return arr.indexOf;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/indexOf.js
// module id = 77
// module chunks = 0